<template>
  <div id="app">
   <router-view></router-view>
  </div>
</template>

<script>
    import http from './http'
export default {
    name: 'app',
    components: {
    },
    created(){
        if(localStorage.currentUser){
            const currentUser=localStorage.currentUser;
            this.$store.dispatch("setIsAutnenticated", !this.isEmpty(currentUser));
            this.$store.dispatch('setUser',currentUser);
        }
    },
    methods:{
        isEmpty(value) {
            return (
                value === undefined ||
                value === null ||
                (typeof value === "object" && Object.keys(value).length === 0) ||
                (typeof value === "string" && value.trim().length === 0)
            );
        }
    }
}
</script>

<style>
    html,
    body,
    #app {
        width: 100%;
        height: 100%;
    }
    /*  .el-dialog__header{
        background-color: #009688de
      }*/
    .el-dialog__body{
        padding: 10px 15px !important;
    }
    .el-table th{
        padding: 8px 0 !important;
    }
    .el-table td{
        padding: 5px 0 !important;
    }
    .el-form-item {
        margin-bottom: 20px !important;
    }
</style>
